const SESSION_ENDPOINT = "/api/auth/get-session";

export function authSessionRequestUrl() {
  const nonce =
    globalThis.crypto?.randomUUID?.() ??
    `${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
  return `${SESSION_ENDPOINT}?_auth=${encodeURIComponent(nonce)}`;
}

export function fetchAuthSession(signal?: AbortSignal) {
  return fetch(authSessionRequestUrl(), {
    credentials: "include",
    cache: "no-store",
    headers: {
      accept: "application/json",
      "cache-control": "no-cache",
      pragma: "no-cache",
    },
    ...(signal ? { signal } : {}),
  });
}
